import React, { useState } from 'react';
import { Card, Space, Typography, Input } from 'antd';
import { LeftOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import CsvExcelImport from '../../../components/common/CsvExcelImport';
import Button from '../../../components/common/Button';

const { Title } = Typography;

const CorCsvExcelImport: React.FC = () => {
  const navigate = useNavigate();
  const [targetTable, setTargetTable] = useState<string>('');

  return (
    <Card
      title={(
        <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
          <Button icon={<LeftOutlined />} type="text" aria-label="Back" onClick={() => navigate(-1)} />
          <Title level={3} style={{ margin: 0 }}>Csv-Excel Import</Title>
        </span>
      )}
      style={{ margin: 24 }}
    >
      <Space direction="vertical" style={{ width: '100%' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <span style={{ minWidth: 140 }}>Target Table:</span>
          <Input
            value={targetTable}
            onChange={(e) => setTargetTable(e.target.value)}
            placeholder="Enter backend table name (e.g. mat_gap_master)"
            style={{ minWidth: 360 }}
          />
        </div>

        {targetTable.trim() ? (
          <CsvExcelImport tableName={targetTable.trim()} />
        ) : null}
      </Space>
    </Card>
  );
};

export default CorCsvExcelImport;
